import { Component } from '@angular/core';
import { TabContainerConfig } from '@nebula-layout/layout';
import { TabContainerWrapperComponent } from '@nebula-vault/layout';

import { TabItem } from 'nebula-ui-kit';

@Component({
  selector: 'app-vault',
  standalone: true,
  imports: [TabContainerWrapperComponent],
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 0;
        height: 100%;
        width: 100%;
      }
    `,
  ],
  template: `
    <app-tab-container-wrapper
      [config]="tabConfig"
      [showClose]="true"
      [contentMinHeight]="'0'"
      [emptyMessage]="'Selecciona una opción de Vault para comenzar'"
      (tabActivated)="onTabActivated($event)"
      (tabClosed)="onTabClosed($event)"
    >
    </app-tab-container-wrapper>
  `,
})
export class VaultComponent {
  readonly tabConfig: TabContainerConfig = {
    moduleKey: 'vault',
    moduleLabel: 'Vault',
    enableBreadcrumb: true,
    enableUrlSync: true,
  };

  onTabActivated(_tab: TabItem): void {
    // on tab activated
  }

  onTabClosed(_tabId: string): void {
    // on tab
  }
}
